<template>
  <div class="about-introduce">
      <Ban :urls="[banner]" :tabs="tabs"/>
      <div class="box" style="margin-top:80px;">
        <div class="title">
          <div class="sub-title">
            <h1 v-if="language === '2'">OUR BUSINESS</h1>
            <h1 v-else>我们的事业</h1>
          </div>
        </div>
        <div class="text">
          <p v-if="language === '2'">Mafco Worldwide is the global leader in manufactured licorice products with a history of industry leadership for more than 170 years. Mafco's technological innovation, significant capital investments, continuous quality improvements, high-level of customer service and best-in-class security of supply clearly distinguish Mafco from all other suppliers. Mafco licorice products are the industry quality standard for food, pharmaceutical and personal care product applications.</p>
          <p v-else style="text-align: center">麦福环球是甘草制品界的全球引领者,距今已有170多年历史。通过不断的技术创新,大量的资金投入、执着的品质提升、高水平的客户服务和一流的原材料供应保证使得麦福从所有供应商中脱颖而出。麦福甘草制品的品质即代表了食品,制药和日化应用的行业质量标准。</p>
        </div>
      </div>

      <div class="box clearfix">
        <div class="title">
          <div class="sub-title">
            <h1 v-if="language === '2'">MAFCO QUALITY</h1>
            <h1 v-else>麦福品质</h1>
          </div>
        </div>
        <div class="text our-success" :style="{padding: language === '1' ? '40px 310px' : '40px 120px'}">
          <ul v-if="language === '2'">
            <li>
              <p>Mafco products set the standard for excellence in the licorice product industry</p>
            </li>
            <li>
              <p>Mafco products meet the highest quality standards for customers in Asia, the EU and the Americas</p>
            </li>
            <li>
              <p>Mafco continuously develops new licorice products and technologies for the separation of licorice solids from licorice root</p>
            </li>
            <li>
              <p>Mafco has a global manufacturing and distribution platform to ensure complete security of supply for its customers</p>
            </li>
          </ul>
          <ul v-else>
            <li>
              <p>麦福制品为甘草制品行业树立了卓越的标准</p>
            </li>
            <li>
              <p>麦福制品符合亚洲、欧盟和美洲客户的最高质量标准</p>
            </li>
            <li>
              <p>麦福不断提升技术，以开发出更多甘草制品</p>
            </li>
            <li>
              <p>麦福拥有全球制造和分销平台网络，以保障对客户的稳定供应</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="box">
        <div class="title">
          <div class="sub-title">
            <h1 v-if="language === '2'">OUR HISTORY</h1>
            <h1 v-else>我们的历史</h1>
          </div>
        </div>
        <div class="text">
          <!-- <template v-if="language === '2'">
            <p>1850 Edward MacAndrews and William Forbes started a business in Turkey to ship licorice roots and manufacture licorice extracts under the name MacAndrews and Forbes Company.</p>
            <p>1903 A new factory was constructed in Camden, NJ in order to manufacture large quantities of licorice extract. Mafco continued to operate at this factory site today.</p>
            <p>1981 The company was renamed as Mafco and purchased as the subsidiary in MacAndrews and Forbes Group.</p>
            <p>1986 Mafco acquired Extraits Végétaux et Dérivés company in France, in order to expand its licorice manufacturing capacity and its customer base in continental Europe.</p>
            <p>2004 Mafco entered into a new joint venture to construct a new modern factory in Zhangjiagang Free Trade Zone in China, which committed to producing high quality licorice derivatives.</p>
            <p>2007 Mafco purchased the remaining shares of its Chinese licorice derivatives manufacturing joint venture. So far, Zhangjiagang Free Trade Zone Mafco Biotech Co., Ltd became the wholly owned subsidiary of Mafco.</p>
            <p>2012 Mafco acquired Shanghai Fanzhi Pharmaceutical Co., Ltd (It was renamed as Shanghai Mafco Biotech Co., Ltd in 2016) which became Mafco's another Licorice derivative manufacturing company in China.</p>
          </template>
          <template v-else>
            <p>1850年，爱德华·迈克安德鲁斯和威廉·福布斯在土耳其创立了MacAndrews and Forbes公司，开始运输甘草并生产甘草提取物。</p>
            <p>1903年时工厂迁移至目前所在地：美国新泽西州的卡姆登市。至此，公司就一直在美国生产和经营。</p>
            <p>1981年公司更名为Mafco，成为MacAndrews and Forbes Group的子公司。</p>
            <p>1986年Mafco并购法国的Extraits Végétaux et Dérivés公司，进一步拓展欧洲大陆的甘草生产及客户基础。</p>
            <p>2004年Mafco以合资企业的形式在中国张家港保税区建立一家现代工厂，致力于生产高质量的甘草衍生物。</p>
            <p>2007年Mafco收购了中国张家港企业所有股份，至此张家港麦福生物制品有限公司成为Mafco的全资子公司。</p>
            <p>2012年麦福收购上海泛植制药有限公司（并于2016年更名为上海麦福生物制品有限公司），成为Mafco在中国另一家甘草衍生物制造公司。</p>
          </template> -->
          <History />
        </div>
      </div>

      <Footer />
  </div>
</template>
<script>
import Ban from '@/components/sub-page-banner.vue'
import Footer from '@/components/Footer.vue'
import History from '@/views/Home/components/History.vue'
export default {
  components: {
    Footer, Ban, History
  },
  data () {
    return {
      tabs: [{
        title: '关于Mafco',
        titleEN: 'About Mafco',
        isActive: true
      }],
      banner: require('../../assets/img/sub-banner/about.jpg')
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  mounted () {
    this.showPage = true
  }
}
</script>
<style scoped lang="scss">

.about-introduce {
  margin-top: 88px;
  .box {
    overflow: hidden;
    clear: both;
    background-color: #f5f5f5;
    width: 1280px;
    margin: 0 auto;
    // display: flex;
    border-bottom: solid 2px #eee;
    * {
      font-size: 16px;
      color: #333;
    }
    .title {
      padding-top: 100px;
      // width: 30%;
      height: inherit;
      // display: inline-flex;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 22px;
      }
      h1, h2 {
        margin: 0;
        text-align: center;
        color: #111;
        position: relative;
        padding-bottom: 20px;
      }
      // h2 {
      //   font-size: 16px;
      //   color: #666;
      // }
      h1::after,
      h2::after {
        content: "";
        position: absolute;
        width: 100px;
        height: 4px;
        display: block;
        background: #005836;
        left: 50%;
        bottom: 0;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
      }
    }
    .text {
      text-align: left;
      padding: 40px 140px;
      font-size: 14px;
      color: #333;
      &.our-success {
        li {
          color: green;
        }
      }
    }
  }
  .box:first-of-type {
    margin-top: 88px;
  }
  .box:last-of-type {
    margin-bottom: 150px;
  }

  p, ul {
    line-height: 40px;
    max-width: 1280px;
    margin: 0 auto;
  }
}
</style>
